// extracted by mini-css-extract-plugin
export default {"container":"bB_d","arrowLeft":"bB_gB","arrowRight":"bB_gC","dots":"bB_gD"};